import React, {useState} from 'react';
import {Box} from '@mui/material';
import {t} from '../../themes/statamicTokens';

export const StatamicTabs = ({tabs, value, onChange, sx}) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            px: 3,
            borderBottom: `1px solid ${t.color.border.default}`,
            ...sx,
        }}
    >
        {tabs.map(tab => {
            const active = tab.id === value;
            return (
                <Box
                    key={tab.id}
                    onClick={() => onChange?.(tab.id)}
                    sx={{
                        px: 1.5,
                        py: 1.25,
                        cursor: 'pointer',
                        fontSize: `${t.type.small.size}px`,
                        fontWeight: active ? 600 : 500,
                        color: active ? t.color.accent.primary : t.color.text.secondary,
                        borderBottom: active
                            ? `2px solid ${t.color.accent.primary}`
                            : '2px solid transparent',
                        marginBottom: '-1px',
                        transition: 'color 120ms ease',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 0.75,
                        '&:hover': { color: t.color.text.primary },
                    }}
                >
                    {tab.icon}
                    {tab.label}
                    {typeof tab.count === 'number' && (
                        <Box
                            component="span"
                            sx={{
                                ml: 0.5,
                                px: 0.75,
                                py: 0.125,
                                fontSize: 11,
                                fontWeight: 600,
                                color: active ? t.color.accent.primary : t.color.text.muted,
                                backgroundColor: active ? t.color.accent.primaryTint : t.color.chip.bg,
                                borderRadius: `${t.radius.pill}px`,
                            }}
                        >
                            {tab.count}
                        </Box>
                    )}
                </Box>
            );
        })}
    </Box>
);

export const useTabs = (initial) => {
    const [value, setValue] = useState(initial);
    return [value, setValue];
};

export default StatamicTabs;
